import React from "react";

const BlogsImg = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="608.84067"
      height="481.8936"
      viewBox="0 0 808.84067 681.8936"
      role="img"
      artist="Katerina Limpitsouni"
      source="https://undraw.co/"
      className={className}
    >
      <path
        d="M866.24553,659.31387,597.90045,536.80922,736.07526,234.13885l268.34507,122.50466Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#f2f2f2"
      />
      <path
        d="M907.12341,483.47827l-203.14462-92.7394a1.58594,1.58594,0,0,1,1.31725-2.88543l203.14462,92.7394a1.58594,1.58594,0,0,1-1.31725,2.88543Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M918.41962,458.73405,715.275,365.99465a1.58594,1.58594,0,1,1,1.31725-2.88543l203.14462,92.7394a1.58594,1.58594,0,1,1-1.31725,2.88543Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M929.71583,433.98984,726.57121,341.25043a1.58594,1.58594,0,1,1,1.31725-2.88543l203.14462,92.7394a1.58595,1.58595,0,0,1-1.31725,2.88544Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M941.012,409.24562,737.86742,316.50621a1.58594,1.58594,0,1,1,1.31725-2.88543l203.14462,92.73941a1.58594,1.58594,0,0,1-1.31725,2.88543Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M896.91469,505.84036,693.77007,413.101a1.58594,1.58594,0,1,1,1.31725-2.88543l203.14462,92.7394a1.58594,1.58594,0,0,1-1.31725,2.88543Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M930.83742,372.9484,772.15573,300.50717a3.9649,3.9649,0,0,1-2.22982-4.77891,3.816,3.816,0,0,1,5.20033-2.25249L933.75967,365.895a4.00065,4.00065,0,0,1,2.261,4.85011A3.81579,3.81579,0,0,1,930.83742,372.9484Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M320.27065,356.64351,588.61572,234.13885,726.79053,536.80922,458.44546,659.31387Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#f2f2f2"
      />
      <path
        d="M417.56758,483.47827l203.14461-92.7394a1.58594,1.58594,0,1,0-1.31725-2.88543l-203.14462,92.7394a1.58594,1.58594,0,1,0,1.31726,2.88543Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M406.27137,458.73405,609.416,365.99465a1.58594,1.58594,0,0,0-1.31726-2.88543l-203.14462,92.7394a1.58594,1.58594,0,1,0,1.31726,2.88543Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M394.97516,433.98984l203.14462-92.73941a1.58594,1.58594,0,0,0-1.31726-2.88543L393.6579,431.1044a1.58595,1.58595,0,0,0,1.31726,2.88544Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M383.679,409.24562l203.14462-92.73941a1.58594,1.58594,0,1,0-1.31726-2.88543L382.36169,406.36019a1.58594,1.58594,0,0,0,1.31726,2.88543Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M427.7763,505.84036,630.92092,413.101a1.58594,1.58594,0,0,0-1.31726-2.88543L426.459,502.95493a1.58594,1.58594,0,1,0,1.31726,2.88543Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M393.85356,372.9484l158.68169-72.44123a3.96488,3.96488,0,0,0,2.22982-4.77891,3.816,3.816,0,0,0-5.20032-2.25249L390.93131,365.895a4.00067,4.00067,0,0,0-2.261,4.85011A3.81579,3.81579,0,0,0,393.85356,372.9484Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />

      <path
        d="M263.34042,651.68609a103.56706,103.56706,0,0,0-22.24942,59.71,44.59937,44.59937,0,0,0,1.33347,13.91012,25.57977,25.57977,0,0,0,7.05351,11.46684c3.04906,2.97518,6.51244,5.66536,8.78518,9.32991a15.66257,15.66257,0,0,1,1.52111,12.71858c-1.50058,5.29374-4.81379,9.73259-8.20469,13.96082-3.76494,4.69464-7.74992,9.51126-9.11223,15.51981-.16506.728-1.28505.42933-1.12024-.29759,2.37018-10.45385,12.00015-16.88329,16.20867-26.422,1.96377-4.45092,2.5981-9.52061.24636-13.9565-2.05648-3.879-5.62559-6.6562-8.73886-9.64195a27.29558,27.29558,0,0,1-7.31456-10.95513,41.23112,41.23112,0,0,1-1.86335-13.80753,100.47854,100.47854,0,0,1,5.51711-30.9156,105.40343,105.40343,0,0,1,17.12084-31.44219c.46185-.58333,1.27593.24285.8171.82236Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M240.987,704.37553a15.53836,15.53836,0,0,1-12.771-15.548.58005.58005,0,0,1,1.15934-.01084,14.38817,14.38817,0,0,0,11.90924,14.43856c.73455.12924.43276,1.24874-.29759,1.12023Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M247.73331,735.46815a29.94891,29.94891,0,0,0,12.329-18.01017c.16764-.72741,1.28767-.42894,1.12024.29759A31.15139,31.15139,0,0,1,248.315,736.47071c-.619.41865-1.19736-.58618-.5817-1.00256Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M250.4132,671.958a8.79547,8.79547,0,0,0,8.29544-.916c.61341-.42629,1.19112.579.5817,1.00255a9.856,9.856,0,0,1-9.17473,1.0337.599.599,0,0,1-.41132-.70892.58248.58248,0,0,1,.70891-.41132Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />

      <path
        d="M291.92419,722.40742a15.53837,15.53837,0,0,1-.836-20.10319c.46083-.58635,1.39363.10222.93219.68934a14.38819,14.38819,0,0,0,.81585,18.69857c.5087.54544-.40628,1.2576-.91207.71528Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M278.59082,751.29486a29.94894,29.94894,0,0,0,20.68738-6.9572c.5718-.47987,1.28639.43278.71528.91207a31.15143,31.15143,0,0,1-21.54181,7.19584c-.74632-.03843-.60311-1.18893.13915-1.15071Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M318.96807,702.199a8.79545,8.79545,0,0,0,7.17495,4.263c.74643.029.60242,1.17947-.13915,1.15071a9.856,9.856,0,0,1-7.94787-4.69847.599.599,0,0,1,.0984-.81367.58246.58246,0,0,1,.81367.09839Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M861.997,661.85822H460.74089V209.2756H861.997Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M861.997,661.85822H460.74089V209.2756H861.997Zm-399.09877-2.15729H859.83966v-448.268H462.89818Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#cacaca"
      />
      <path
        d="M813.24987,421.18544H509.488a2.15729,2.15729,0,1,1,0-4.31458h303.7619a2.15729,2.15729,0,0,1,0,4.31458Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#e4e4e4"
      />
      <path
        d="M813.24987,384.18544H509.488a2.15729,2.15729,0,1,1,0-4.31458h303.7619a2.15729,2.15729,0,0,1,0,4.31458Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#e4e4e4"
      />
      <path
        d="M813.24987,347.18544H509.488a2.15729,2.15729,0,1,1,0-4.31458h303.7619a2.15729,2.15729,0,0,1,0,4.31458Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#e4e4e4"
      />
      <path
        d="M813.24987,310.18544H509.488a2.15729,2.15729,0,1,1,0-4.31458h303.7619a2.15729,2.15729,0,0,1,0,4.31458Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#e4e4e4"
      />
      <path
        d="M813.24987,454.62344H509.488a2.15729,2.15729,0,1,1,0-4.31458h303.7619a2.15729,2.15729,0,0,1,0,4.31458Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#e4e4e4"
      />
      <path
        d="M813.24987,620.62344H509.488a2.15729,2.15729,0,1,1,0-4.31458h303.7619a2.15729,2.15729,0,0,1,0,4.31458Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#e4e4e4"
      />
      <path
        d="M740.48441,585.9937h-158.231a3.99339,3.99339,0,0,1-3.989-3.989V488.92762a3.99338,3.99338,0,0,1,3.989-3.989h158.231a3.99337,3.99337,0,0,1,3.989,3.989v93.07706A3.99338,3.99338,0,0,1,740.48441,585.9937Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#fff"
      />
      <path
        d="M687.64325,532.82035a8.8014,8.8014,0,0,0-12.64552-.226L630.46735,577.125a6.28787,6.28787,0,0,1-8.86881.01331l-6.59513-6.58189a8.78014,8.78014,0,0,0-12.41958,0L589.8195,583.33459H732.91833v-1.82165Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#2C55E5"
      />
      <path
        d="M740.48441,585.9937h-158.231a3.99339,3.99339,0,0,1-3.989-3.989V488.92762a3.99338,3.99338,0,0,1,3.989-3.989h158.231a3.99337,3.99337,0,0,1,3.989,3.989v93.07706A3.99338,3.99338,0,0,1,740.48441,585.9937ZM582.25342,487.598a1.3312,1.3312,0,0,0-1.32967,1.32967v93.07706a1.33119,1.33119,0,0,0,1.32967,1.32967h158.231a1.33119,1.33119,0,0,0,1.32968-1.32967V488.92762a1.3312,1.3312,0,0,0-1.32968-1.32967Z"
        transform="translate(-195.57967 -109.0532)"
        fill="#3f3d56"
      />
    </svg>
  );
};
export default BlogsImg;
